import React from "react";

import { Grid } from "@mui/material";

import { ESupplyChainOverviewTabs, ProductsConfigure } from "../../../../../models/supply.chain.overview.configure";
import { useSupplyChainOverviewContext } from "../../context";
import ConfigWidget from "../ConfigWidget";

const ProductsConfig = () => {
  const { config, dashboard, handleWidgetConfigChange } = useSupplyChainOverviewContext();

  const configs: Array<keyof ProductsConfigure> = [
    "productsOrigin",
    "mostRequestedProducts",
    "productsRunningOutOfStock",
  ];

  return (
    <Grid container spacing={0}>
      {configs.map((label: keyof ProductsConfigure) => (
        <Grid item key={`productsConfig-${label}`} xs={4}>
          <ConfigWidget
            handleChange={(value) => handleWidgetConfigChange(ESupplyChainOverviewTabs.PRODUCTS, label, value)}
            label={label}
            type={dashboard.products?.graphs[label].type}
            value={config.products[label] as boolean}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductsConfig;
